export default class PaginationService {
  get_pagination(data) {
    var per_page = 10;
    var pagination = {
      first_record: 0, last_record: 0,
      total_records: 0, pages: []
    };
    if (data.display_count > 0) {
      pagination.first_record = (data.page - 1) * per_page + 1;
      pagination.last_record = pagination.first_record + data.display_count - 1;
    }
    pagination.total_records = data.total_entries;
    for (var i = 1; i < data.total_pages + 1; i++)
      pagination.pages.push(i);
    return pagination;
  }
}



// WEBPACK FOOTER //
// ./front/js/admin/services/pagination.service.js